/* PPC Tracking */
loadScriptCMM(
  '//cdn.rlets.com/capture_configs/e58/764/fea/9624620874dcc49ba608da3.js',
  null,
  { async: true },
);

/** Callrail Tracking */
loadScriptCMM(
  '//cdn.callrail.com/companies/154916396/503b6493e5f57ad91a03/12/swap.js',
);

/* Header Contact Banner */
CMMBanner.make(
  [
    {
      text: [
        {
          content:
            'Proudly serving Mobile, Alabama (AL) and the surrounding areas',
        },
      ],
    },
    {
      text: CMMBanner.createSimpleButtons([
        CMMBanner.Button.Presets.DIRECTIONS({
          link: 'http://www.google.com/maps/search/?api=1&query=All+About+The+Windows+3900+Cottage+Hill+Rd+%2CMobile%2CAL+36609-6512',
        }),
        CMMBanner.Button.Presets.PHONE({
          link: 'tel:+12517251486',
        }),
      ]),
    },
  ],
  {
    presets: [CMMBanner.Presets.HEADER_CONTACT],
  },
);

/* ConvertBoost */
CMMConvertBoost.make({
  modal: CMMConvertBoost.Modal.Presets.Default({
    buttons: [
      CMMConvertBoost.ButtonModal.Presets.PHONE({
        link: 'tel:+12517251486',
      }),
      CMMConvertBoost.ButtonModal.Presets.DIRECTIONS({
        link: 'http://www.google.com/maps/search/?api=1&query=All+About+The+Windows+3900+Cottage+Hill+Rd+%2CMobile%2CAL+36609-6512',
      }),
      CMMConvertBoost.ButtonModal.Presets.CONSULTATION_HD({}),
    ],
  }),
  buttons: [
    CMMConvertBoost.ButtonFloating.Presets.PHONE({
      action: {
        link: 'tel:+12517251486',
      },
    }),
    CMMConvertBoost.ButtonFloating.Presets.DIRECTIONS({
      action: {
        link: 'http://www.google.com/maps/search/?api=1&query=All+About+The+Windows+3900+Cottage+Hill+Rd+%2CMobile%2CAL+36609-6512',
      },
    }),
    CMMConvertBoost.ButtonFloating.Presets.CONSULTATION_HD({}),
    CMMConvertBoost.ButtonFloating.Presets.MODAL({}),
  ],
}).then(() => {
  /* Google Ads Conversions */
  loadGoogleAdsConversions({
    account: 'AW-17105507645',
    enhanced_conversions: true,
    conversions: [
      {
        label: '_B0vCM-1jcwaEL2qxdw_',
        selector: 'form_submission',
        trigger: 'lead',
        enhancedConversionMapping: true,
      },
      {
        label: 'd88eCLmLgMwaEL2qxdw_',
        selector: CMM_DIRECTIONS_SELECTORS.join(','),
        trigger: 'click',
      },
      {
        label: 's72uCObejcwaEL2qxdw_',
        phoneConversionNumber: '(251) 725-1486',
      },
      {
        label: 'EH3jCLOmjcwaEL2qxdw_',
        phoneConversionNumber: '(251) 583-1678',
      },
    ],
  });
});

/* Smooth Scrolling */
cmmSmoothScrollInit();

/* Site-Wide Footer Blurb */
var txtFooter =
  'We are a local window fashions dealer who offers the full selection of Hunter Douglas custom window treatments, including horizontal blinds, vertical blinds, roman shades, roller shades (including solar shades and screen shades), sheer shadings, honeycomb cellular shades, woven wood shades, and plantation shutters. We also offer custom drapery, motorized window coverings, and patio screen shades. We also particularly specialize in providing commercial blinds and shades. We have showrooms located in Mobile, Alabama (AL), and proudly serve the surrounding area, including Spanish Fort, Daphne, Point Clear, Bay Minette, Foley, Robertsdale, Loxley, Orange Beach, Gulf Shores, and Mobile.';
footerBlurb(txtFooter);

/* Custom Metadata */
cmmUpdateMetadata({
  'hunter-douglas/shades/sheer-shades': {
    t: 'Hunter Douglas Sheer Shades | All About The Windows',
    d: 'Enjoy Hunter Douglas sheer shades near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear, Bay Minette, Foley and Robertsdale, Alabama.',
  },
  'hunter-douglas/shades/cellular-shades': {
    t: 'Hunter Douglas Cellular Shades | All About The Windows',
    d: 'Upgrade your home with honeycomb shades like Hunter Douglas Cellular Shades near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear and Robertsdale, Alabama.',
  },
  'hunter-douglas/shades/roman-shades': {
    t: 'Hunter Douglas Roman Shades | All About The Windows',
    d: 'Learn more about Hunter Douglas Roman Shades near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear, Bay Minette, Foley and Robertsdale, Alabama.',
  },
  'hunter-douglas/shades/roller-shades': {
    t: 'Hunter Douglas Roller Shades | All About The Windows',
    d: 'Find the perfect shades with Hunter Douglas Roller and Solar Shades near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear, Foley and Robertsdale, Alabama.',
  },
  'hunter-douglas/shades/woven-shades': {
    t: 'Hunter Douglas Woven Shades | All About The Windows',
    d: 'Also known as bamboo shades, learn more about Hunter Douglas Woven Shades near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear, Foley and Robertsdale, Alabama.',
  },
  'hunter-douglas/shades/vertical-shades': {
    t: 'Hunter Douglas vertical Blinds | All About The Windows',
    d: 'Learn about the benefits of Hunter Douglas Vertical Shades near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear, Bay Minette, Foley and Robertsdale, Alabama.',
  },
  'hunter-douglas/shutters': {
    t: 'Hunter Douglas Plantation Shutters | All About The Windows',
    d: 'Commonly known as plantation shutters, learn about Hunter Douglas Shutters near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear, Foley, and Robertsdale, Alabama.',
  },
  'hunter-douglas/blinds/vertical-blinds': {
    t: 'Hunter Douglas vertical Blinds | All About The Windows',
    d: 'Learn more about stylish options like Hunter Douglas Vertical Blinds near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear, Foley and Robertsdale, Alabama.',
  },
  'hunter-douglas/blinds/wood-blinds': {
    t: 'Hunter Douglas Wood Blinds | All About The Windows',
    d: 'Enjoy the natural beauty of Hunter Douglas Wood Blinds near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear, Bay Minette, Foley and Robertsdale, Alabama.',
  },
  'hunter-douglas/blinds/metal-blinds': {
    t: 'Hunter Douglas metal Blinds | All About The Windows',
    d: 'Also known as aluminum blinds, learn more about Hunter Douglas Metal Blinds near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear and Robertsdale, Alabama.',
  },
  'hunter-douglas/drapery': {
    t: 'Hunter Douglas Drapery | All About The Windows',
    d: 'We have a wide selection of Hunter Douglas Drapery, Valance Curtains, and Living Room Curtains near Mobile, Spanish Fort, Daphne and Robertsdale, Alabama.',
  },
  'hunter-douglas/powerview-automation': {
    t: 'Hunter Douglas PowerView® Automation | All About The Windows',
    d: 'Modernize your home with motorized blinds, also known as automatic blinds. Learn more about motorized window treatments near Mobile, Alabama.',
  },
  'hunter-douglas/featured/room-darkening': {
    t: 'Room Darkening | All About The Windows',
    d: 'Find room-darkening shades and blackout curtains for your home! Contact us near Mobile, Alabama to learn more today!',
  },
  'hunter-douglas/featured/energy-efficient': {
    t: 'Energy Efficiency | All About The Windows',
    d: 'Create a more energy-efficient home with All About The Windows. Our Hunter Douglas window treatments near Mobile, Spanish Fort and Robertsdale, Alabama.',
  },
  'hunter-douglas/featured/light-enhancing': {
    t: 'Light Enhancing | All About The Windows',
    d: 'Enjoy more light in your home with Hunter Douglas window treatments near Mobile, Alabama.',
  },
  'hunter-douglas/featured/door-coverings': {
    t: 'Door Covering | All About The Windows',
    d: 'Find the ideal door cover or room divider with Hunter Douglas Window Treatments near Mobile, Spanish Fort, Daphne, Fairhope, Point Clear and Robertsdale, Alabama.',
  },
  'hunter-douglas/featured/sound-absorption': {
    t: 'Sound Absorption | All About The Windows',
    d: "Increase your home's comfort with sound-absorbing window treatments from Hunter Douglas. Contact us near Mobile, Alabama to learn more today!",
  },
  'hunter-douglas/featured/top-down-bottom-up-shades': {
    t: 'Top-Down, Bottom-Up | All About The Windows',
    d: 'Enjoy privacy and light control in your home with Top-Down, Bottom-Up window treatments from Hunter Douglas. Contact us Mobile, Alabama  learn more!',
  },
});
